import type { HireReference, HireReferences, PeopleStaffingChange, PeopleWorker } from './model';

export const fixturePeopleWorkers: PeopleWorker[] = [
  {
    id: '01', personId: 'person-01', workerNumber: 'A0001', name: '정성진', initials: '정',
    organization: '한결', title: '대표이사', jobLevel: 'L7', jobType: '정규직', jobTypeId: 'job-type-regular',
    company: '주식회사 한결', timeType: 'FULL_TIME', location: '서울 본사', locationId: 'location-seoul',
    workSpace: '4층 Executive Zone', workSpaceId: 'work-space-seoul-executive', status: '재직',
    email: 'sungjin.jung@example.com', phone: '010-1000-1000', hireDate: '2020.01.01', manager: '-',
    workerType: 'Employee', workerTypeId: 'EMPLOYEE', additionalJobs: [],
  },
  {
    id: '02', personId: 'person-02', workerNumber: 'A0104', name: '우디(박진우)', initials: '우디',
    organization: 'Engineering Division', title: 'Engineering Director', jobFamily: 'Engineering', jobLevel: 'L6',
    jobType: '정규직', jobTypeId: 'job-type-regular', company: '주식회사 한결', timeType: 'FULL_TIME',
    location: '서울 본사', locationId: 'location-seoul', workSpace: '4층 Engineering Zone',
    workSpaceId: 'work-space-seoul-4f', status: '재직', email: 'jinwoo.park@example.com', phone: '010-2104-2104',
    hireDate: '2021.03.15', manager: '정성진', workerType: 'Employee', workerTypeId: 'EMPLOYEE',
    additionalJobs: [
      {
        id: 'additional-02', title: '기술 자문', jobFamily: 'Product & Technology', jobLevel: 'L6',
        jobType: '정규직', timeType: 'FULL_TIME', organization: 'Product Division', location: '서울 본사',
        workSpace: '5층 Product Zone',
      },
      {
        id: 'additional-02-data', title: '아키텍처 자문', jobFamily: 'Data & AI', jobLevel: 'L6',
        jobType: '정규직', timeType: 'FULL_TIME', organization: 'Data & AI Division', location: '서울 본사',
      },
    ],
  },
  {
    id: '03', personId: 'person-03', workerNumber: 'A0142', name: '김민서', initials: '김',
    organization: 'Product Division', title: 'Product Manager', jobLevel: 'L4', jobType: '정규직',
    jobTypeId: 'job-type-regular', company: '주식회사 한결', timeType: 'FULL_TIME', location: '서울 본사',
    locationId: 'location-seoul', workSpace: '5층 Product Zone', workSpaceId: 'work-space-seoul-5f', status: '재직',
    email: 'minseo.kim@example.com', phone: '010-2142-2142', hireDate: '2023.03.02', manager: '윤서연',
    workerType: 'Employee', workerTypeId: 'EMPLOYEE', additionalJobs: [],
  },
  {
    id: '04', personId: 'person-04', workerNumber: 'A0188', name: '이수연', initials: '이',
    organization: 'Design Team', title: 'Product Designer', jobLevel: 'L3', company: '주식회사 한결',
    timeType: 'FULL_TIME', location: '서울 본사', status: '휴직', email: 'sooyeon.lee@example.com',
    phone: '010-2188-2188', hireDate: '2022.09.05', manager: '최지훈', workerType: 'Employee', additionalJobs: [],
  },
  {
    id: '05', personId: 'person-05', workerNumber: 'A0203', name: '한도윤', initials: '한',
    organization: 'Business Division', title: 'Growth Manager', jobLevel: 'L4', company: '주식회사 한결',
    timeType: 'FULL_TIME', location: '제주 지점', status: '재직', email: 'doyoon.han@example.com',
    phone: '010-2203-2203', hireDate: '2024.01.08', manager: '김서영', workerType: 'Employee', additionalJobs: [],
  },
  {
    id: '06', personId: 'person-06', workerNumber: 'A0221', name: '강예린', initials: '강',
    organization: 'People & Culture', title: 'HR Operations Manager', jobLevel: 'L4', company: '주식회사 한결',
    timeType: 'FULL_TIME', location: '서울 본사', status: '재직', email: 'yerin.kang@example.com',
    phone: '010-2221-2221', hireDate: '2023.11.20', manager: '이정연', workerType: 'Employee', additionalJobs: [],
  },
  {
    id: '07', personId: 'person-07', workerNumber: 'A0238', name: '장우진', initials: '장',
    organization: 'Platform Engineering Team', title: 'Backend Engineer', jobLevel: 'L3', company: '주식회사 한결',
    timeType: 'FULL_TIME', location: '경북 지점', status: '퇴직 예정', email: 'woojin.jang@example.com',
    phone: '010-2238-2238', hireDate: '2022.05.16', manager: '우디(박진우)', workerType: 'Employee',
    terminationDate: '2026.08.31', additionalJobs: [],
  },
];

export const fixturePeopleStaffingChanges: PeopleStaffingChange[] = [
  {
    id: 'change-1', descriptor: '박준호 입사', processType: 'HIRE',
    subject: { id: 'person-1', descriptor: '박준호' }, person: { id: 'person-1', descriptor: '박준호' },
    effectiveDate: '2026-09-01', status: 'IN_PROGRESS', createdAt: '2026-08-15T00:00:00Z',
    changes: [
      { field: 'status', label: '재직 상태', before: '등록 전', after: '재직' },
      { field: 'organization', label: '소속 조직', before: '-', after: 'Engineering Division' },
    ],
  },
  {
    id: 'change-2', descriptor: '우디(박진우) 조직 변경', processType: 'JOB_CHANGE',
    subject: { id: '02', descriptor: '우디(박진우)' }, worker: { id: '02', descriptor: '우디(박진우)' },
    effectiveDate: '2026-09-01', status: 'COMPLETED', createdAt: '2026-08-14T00:00:00Z', completedAt: '2026-08-15T00:00:00Z',
    changes: [
      { field: 'organization', label: '소속 조직', before: 'Engineering Division', after: 'Product Division' },
      { field: 'businessTitle', label: '직함', before: 'Engineering Director', after: 'VP of Product Engineering' },
    ],
  },
  {
    id: 'change-3', descriptor: '장우진 퇴직', processType: 'END_WORKER',
    subject: { id: '07', descriptor: '장우진' }, worker: { id: '07', descriptor: '장우진' },
    effectiveDate: '2026-08-31', status: 'IN_PROGRESS', createdAt: '2026-08-13T00:00:00Z',
    changes: [{ field: 'status', label: '재직 상태', before: '재직', after: '종료' }],
  },
];

export const fixturePeopleJobTypes: Record<'EMPLOYEE' | 'CONTINGENT_WORKER', HireReference[]> = {
  EMPLOYEE: [{ id: 'job-type-regular', descriptor: '정규직' }, { id: 'job-type-fixed-term', descriptor: '기간제' }],
  CONTINGENT_WORKER: [{ id: 'job-type-contractor', descriptor: '용역' }, { id: 'job-type-freelancer', descriptor: '프리랜서' }],
};

export const fixturePeopleWorkSpaces: Record<string, HireReference[]> = {
  'location-seoul': [{ id: 'work-space-seoul-4f', descriptor: '4층 Engineering Zone' }, { id: 'work-space-seoul-5f', descriptor: '5층 Product Zone' }],
};

export const fixturePeopleHireReferences: HireReferences = {
  companies: [{ id: 'company-hangyeol', descriptor: '주식회사 한결' }],
  locations: [{ id: 'location-seoul', descriptor: '서울 본사' }],
  jobs: [{ id: 'job-engineer', descriptor: 'Software Engineer' }],
  levels: [{ id: 'job-level-l3', descriptor: 'L3' }],
  organizations: [
    { id: 'root', descriptor: '한결' },
    { id: 'product', descriptor: 'Product Division' },
    { id: 'engineering', descriptor: 'Engineering Division' },
    { id: 'platform', descriptor: 'Platform Engineering Team' },
    { id: 'backend', descriptor: 'Backend Engineering Team' },
    { id: 'design', descriptor: 'Design Team' },
    { id: 'data-ai', descriptor: 'Data & AI Division' },
    { id: 'business', descriptor: 'Business Division' },
    { id: 'people', descriptor: 'People & Culture' },
  ],
};

// 미리보기에서도 조직 이름 대신 동일한 ID로 주 소속·겸직을 필터링합니다.
for (const worker of fixturePeopleWorkers) {
  worker.organizationId = fixturePeopleHireReferences.organizations.find(organization => organization.descriptor === worker.organization)?.id;
  for (const job of worker.additionalJobs) job.organizationId = fixturePeopleHireReferences.organizations.find(organization => organization.descriptor === job.organization)?.id;
}
